import { RowCards, Typography } from '@weareopenr/component-library';
import { DashboardWidget } from './DashboardWidget';
import { useSchedules } from 'src/hooks/useSchedules/useSchedules';
import { ScheduleStatus, ValidationStatus } from 'src/api/getSchedules/types';
import { useMemo } from 'react';
import { mapSchedules } from 'src/utils/schedules/mapSchedules';
import { StatusChip } from 'src/components/StatusChip/StatusChip';
import { Routes } from 'src/routes';
import styles from './DashboardWidget.module.scss';

export const UpcomingPublishesWidget = () => {
  const { data, isLoading } = useSchedules(ScheduleStatus.SCHEDULED);
  const schedules = useMemo(() => mapSchedules(data?.pages.flatMap((page) => page.data) ?? []), [data]);

  const completed = schedules.filter(
    (schedule) =>
      schedule.validation.status === ValidationStatus.VALIDATED ||
      schedule.validation.status === ValidationStatus.VALIDATION_FAILED,
  );
  const passed = completed.filter((schedule) => schedule.validation.status === ValidationStatus.VALIDATED);

  const failed = completed.filter((schedule) => schedule.validation.status === ValidationStatus.VALIDATION_FAILED);
  const isEmpty = schedules.length === 0;
  const passedValue = completed.length === 0 ? 0 : Math.round((passed.length / completed.length) * 100);

  return (
    <DashboardWidget
      title="Upcoming Publishes"
      emptyCta={
        <div className={styles['widget-empty']}>
          <Typography size="medium" weight="semi-bold">
            No upcoming publishes...
          </Typography>
          <Typography size="medium" weight="regular">
            Publish to see it appear here
          </Typography>
        </div>
      }
      link={{ label: 'View All', to: Routes.PUBLISH_SCHEDULE }}
      isEmpty={isEmpty}
      isLoading={isLoading}
      Kpis={[
        {
          id: 'validation-rate',
          size: 'small',
          value: isEmpty ? 'N/A' : passedValue,
          label: 'Passed',
          testId: 'kpi-upcoming-publishes-passed',
        },
        {
          id: 'errored',
          size: 'small',
          value: isEmpty ? 'N/A' : failed.length,
          label: 'Errored',
          testId: 'kpi-upcoming-publishes-errored',
        },
      ]}
    >
      <RowCards
        rows={schedules.slice(0, 3).map((schedule) => ({
          id: schedule.schedule_id,
          title: schedule.schedule_name ?? 'Untitled',
          meta: [
            {
              key: 'scheduled_for',
              label: `Publish ${new Date(schedule.scheduled_for).toLocaleString()}`,
              colour: 'liquorice',
            },
          ],
          chip: <StatusChip entity="scheduled-publish" status={schedule.validation.status} />,
        }))}
      />
    </DashboardWidget>
  );
};
